module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nhomepage"
  }, [(_vm.topNotices && _vm.topNotices.length) ? _c('TopNotice', {
    attrs: {
      "notices": _vm.topNotices
    }
  }) : _vm._e(), _vm._v(" "), (_vm.midNotices && _vm.midNotices.length) ? _c('MidNotice', {
    attrs: {
      "notices": _vm.midNotices
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bannerTexts && _vm.bannerTexts.length) ? _c('div', {
    staticClass: "nhomepage-banner-area"
  }, [_c('BannerTexts', {
    attrs: {
      "bannerTexts": _vm.bannerTexts
    },
    on: {
      "bannerItemClicked": _vm.noticeClicked
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.bannerImgs && _vm.bannerImgs.length) ? _c('div', {
    staticClass: "nhomepage-banner-imgs"
  }, [_c('BannerImages', {
    attrs: {
      "images": _vm.bannerImgs
    },
    on: {
      "bannerItemClicked": _vm.noticeClicked
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasServiceCard) ? _c('div', {
    staticClass: "home-flex-row"
  }, [_c('HomePageCard', {
    staticClass: "home-recomm-services",
    attrs: {
      "title": "推荐服务"
    }
  }, [_vm._l((_vm.serviceItems), function(data) {
    return [(data.icon !== 'app') ? _c('ServiceItem', {
      key: _vm.bizLineIdNum + data.name,
      attrs: {
        "icon": data.icon,
        "name": data.name,
        "desc": data.desc
      },
      nativeOn: {
        "click": function($event) {
          _vm.servicItemClicked(data)
        }
      }
    }) : _vm._e(), _vm._v(" "), (data.icon === 'app') ? _c('Tooltip', {
      key: data.name,
      attrs: {
        "placement": "right"
      }
    }, [_c('ServiceItem', {
      key: data.name,
      attrs: {
        "icon": data.icon,
        "name": data.name,
        "desc": data.desc,
        "delay": 350
      }
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": "//p0.meituan.net/codeman/8acc947084d6b22070523f39dcb7c91428173.png",
        "width": "226px"
      },
      slot: "content"
    })], 1) : _vm._e()]
  })], 2), _vm._v(" "), _c('HomePageCard', {
    staticClass: "home-recomm-actives",
    attrs: {
      "title": "推荐活动"
    }
  }, [(_vm.activeItems && _vm.activeItems.length) ? _c('ul', _vm._l((_vm.activeItems), function(data) {
    return _c('ActiveItem', {
      key: data.id,
      attrs: {
        "name": data.name,
        "date": data.date,
        "bgclass": data.bg
      }
    })
  })) : _c('div', {
    staticClass: "create-selfpro-tip"
  }, [_c('div', [_c('p', {
    staticClass: "main-desc"
  }, [_vm._v("暂无可参加的活动")]), _vm._v(" "), _c('p', {
    staticClass: "sub-desc"
  }, [_vm._v("自己做促销，同样可以吸引顾客")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.createSelfProClicked
    }
  }, [_vm._v("创建自促活动")])], 1)])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "home-flex-row"
  }, [_c('div', {
    staticClass: "nhomepage-notices"
  }, [_c('Notices', {
    attrs: {
      "title": "平台公告",
      "notices": _vm.notices
    },
    on: {
      "extraClicked": function($event) {
        _vm.moreNoticesClicked(3)
      }
    }
  }), _vm._v(" "), _c('Notices', {
    attrs: {
      "title": "规则中心",
      "notices": _vm.rules
    },
    on: {
      "extraClicked": function($event) {
        _vm.moreNoticesClicked(10)
      }
    }
  })], 1), _vm._v(" "), _c('HomePageCard', {
    staticClass: "nhomepage-xigua-academy",
    attrs: {
      "title": "西瓜学院",
      "extra": "更多"
    },
    on: {
      "extraClick": function($event) {
        _vm.moreNoticesClicked(5)
      }
    }
  }, [_c('ul', {
    staticClass: "course-list"
  }, _vm._l((_vm.courses), function(courseItem) {
    return _c('CourseItem', {
      key: courseItem.id,
      attrs: {
        "src": courseItem.src,
        "title": courseItem.title,
        "subTitle": courseItem.subTitle
      },
      nativeOn: {
        "click": function($event) {
          _vm.noticeClicked(courseItem.id)
        }
      }
    })
  }))])], 1), _vm._v(" "), _c('HomePageFooter')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7be59d06","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nhomepage/nhomepage.vue
// module id = 774
// module chunks = 0